<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Update Details"
              bc1="App"
              bc2="Payment"
              bc3="Update"
              path="payment-method"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <ValidationObserver
                      ref="observer"
                      tag="form"
                      v-slot="{ invalid, validate }"
                  >
                    <form
                        class="form form-horizontal"
                        @submit.prevent="validate().then(sendCall)"
                    >
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label for="name-icon">Name</label>
                            </div>
                            <div class="col-sm-9">
                              <ValidationProvider
                                  name="Name"
                                  ref="name"
                                  rules="required"
                                  v-slot="{ errors }"
                              >
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <span class="input-group-text"
                                    ><i class="far fa-user"></i
                                    ></span>
                                  </div>
                                  <input
                                      type="text"
                                      v-model="name"
                                      id="name-icon"
                                      class="form-control"
                                      :class="errors[0] ? 'is-invalid' : ''"
                                      name="name"
                                      placeholder="Name"
                                      v-validate="'required'"
                                  />
                                </div>
                                <small
                                    class="block text-red-600 text-xs absolute bottom-0 left-0"
                                    style="color:#EA5455"
                                >{{ errors[0] }}</small
                                >
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label for="code-icon">Code</label>
                            </div>
                            <div class="col-sm-9">
                              
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    
                                  </div>
                                  <input
                                      type="text"
                                      v-model="code"
                                      id="code-icon"
                                      class="form-control"
                                      name="code"
                                      placeholder="Code"
                                  />
                                </div>
                               
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group row"></div>
                        </div>
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3">
                              <label for="rate-icon">Enable Independent Settlement</label>
                            </div>
                            <div class="col-sm-9">
                              <input
                                  class="custom-checkbox"
                                  type="checkbox"
                                  v-model="independentSettlement"
                                  :true-value="1"
                                  :false-value="0"
                                  name="independentSettlement"
                              />
                            </div>
                          </div>
                        </div>
<!--                        <div class="col-12">-->
<!--                          <div class="form-group row">-->
<!--                            <div class="col-sm-3">-->
<!--                              <label for="rate-icon">Enable Settings</label>-->
<!--                            </div>-->
<!--                            <div class="col-sm-9">-->
<!--                              <input-->
<!--                                  class="custom-checkbox"-->
<!--                                  type="checkbox"-->
<!--                                  v-model="settingsCheckBox"-->
<!--                                  name="settingsCheckBox"-->
<!--                                  @change="ChangeSettingsCheckBox($event)"-->
<!--                              />-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <PaymentMethodConfigForm ref="paymentMethodSettings" :existingSettings="paymentUpdateData?.settings" :showSettings="settingsCheckBox" />-->
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-12">
                              <div class="form-group row">
                                <div class="col-sm-3">
                                  <label for="rate-icon">
                                    Add withdrawal field
                                  </label>
                                </div>
                                <div class="col-sm-9">
                                  <input
                                      class="custom-checkbox"
                                      type="checkbox"
                                      v-model="checkBoxStatus"
                                      :checked="checkBoxStatus"
                                      @change="ChangewithdrawalCheckBox($event)"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12" v-if="checkBoxStatus">
                          <div class="form-group row">
                            <div class="col-sm-3">
                              <h4>withdrawal Fields</h4>
                            </div>
                          </div>
                        </div>
                        <div class="col-12" v-if="checkBoxStatus">
                          <div
                              v-for="(field, index) in withdrawalField"
                              :key="index"
                              class="added-field"
                          >
                            <div class="col-12 text-right mb-2">
                              <button
                                  type="button"
                                  class="btn btn-danger mr-1"
                                  @click="removeField(index)"
                              >
                                Delete
                              </button>
                            </div>
                            <div class="col-12">
                              <div class="form-group row">
                                <div class="col-sm-3 col-form-label text-right">
                                  <label for="name-icon">Name</label>
                                </div>
                                <div class="col-sm-9">
                                  <ValidationProvider
                                      name="Name"
                                      ref="field.name"
                                      rules="required"
                                      v-slot="{ errors }"
                                  >
                                    <div class="input-group">
                                      <div class="input-group-prepend">
                                        <span class="input-group-text"
                                        ><i class="far fa-user"></i
                                        ></span>
                                      </div>
                                      <input
                                          type="text"
                                          v-model="field.Name"
                                          class="form-control"
                                          :name="field.Name"
                                          placeholder="Name"
                                          v-validate="'required'"
                                          :class="errors[0] ? 'is-invalid' : ''"
                                      />
                                    </div>
                                    <small
                                        class="block text-red-600 text-xs absolute bottom-0 left-0"
                                        style="color:#EA5455"
                                    >{{ errors[0] }}</small
                                    >
                                  </ValidationProvider>
                                </div>
                              </div>
                            </div>

                            <div class="col-12">
                              <div class="form-group row">
                                <div class="col-sm-3 col-form-label text-right">
                                  <label for="name-icon">Type</label>
                                </div>
                                <div class="col-sm-9">
                                  <ValidationProvider
                                      name="Type"
                                      ref="field.type"
                                      rules="required"
                                      v-slot="{ errors }"
                                  >
                                    <div class="input-group">
<!--                                      <div class="input-group-prepend">-->
<!--                                        <span class="input-group-text"-->
<!--                                        ><i class="far fa-edit"></i-->
<!--                                        ></span>-->
<!--                                      </div>-->
<!--                                      <input-->
<!--                                          type="text"-->
<!--                                          v-model="field.type"-->
<!--                                          class="form-control"-->
<!--                                          name="type"-->
<!--                                          placeholder="Type"-->
<!--                                          v-validate="'required'"-->
<!--                                          :class="errors[0] ? 'is-invalid' : ''"-->
<!--                                      />-->
                                      <b-form-select
                                          v-model="field.type"
                                          size="md"
                                          :class="errors[0] ? 'is-invalid' : ''"
                                          v-validate="'required'"
                                          name="field.type"
                                          class="mt-1"
                                      >
                                        <b-form-select-option value=""
                                        >Please Select Type
                                        </b-form-select-option>
                                        <b-form-select-option value="text">
                                          text
                                        </b-form-select-option>
                                        <b-form-select-option value="number">
                                          number
                                        </b-form-select-option>
                                      </b-form-select>
                                    </div>
                                    <small
                                        class="block text-red-600 text-xs absolute bottom-0 left-0"
                                        style="color:#EA5455"
                                    >{{ errors[0] }}</small
                                    >
                                  </ValidationProvider>
                                </div>
                              </div>
                            </div>

                            <div class="col-12">
                              <div class="form-group row align-items-center">
                                <div class="col-sm-3 col-form-label text-right">
                                  <label for="rate-icon">Is Required </label>
                                </div>
                                <div class="col-sm-9">
                                  <input
                                      class="custom-checkbox"
                                      type="checkbox"
                                      v-model="field.required"
                                      :true-value="1"
                                      :false-value="0"
                                      name="isRequiredCheckbox"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                          class="col-sm-6 offset-sm-3 mb-2"
                          v-if="checkBoxStatus"
                      >
                        <button
                            type="button"
                            class="btn btn-success mt-2 mr-1"
                            @click="addMoreField"
                            :disabled="loading"
                        >
                          <i class="fa fa-plus"></i> Add Fields
                        </button>
                      </div>
                      <div class="col-sm-9 offset-sm-3 text-right mt-2 d-flex">
                        <button
                            type="submit"
                            class="btn btn-primary mr-1 d-flex"
                            :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Save
                        </button>
                        <button
                            type="button"
                            class="btn btn-gradient-secondary"
                            @click="$emit('back')"
                        >
                          Back
                        </button>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import {CommandIcon} from "vue-feather-icons";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import PaymentMethodConfigForm from "./PaymentMethodConfigForm.vue";

export default {
  components: {
    CommandIcon,
    ValidationObserver,
    ValidationProvider,
    PaymentMethodConfigForm
  },
  mounted() {
    this.paymentUpdateData = this.$store.getters.getByKey(
        "paymentMethodUpdate"
    );
    if (this.paymentUpdateData) {
      this.index = this.paymentUpdateData.index;
      this.id = this.paymentUpdateData.id;
      this.name = this.paymentUpdateData.name;
      this.code = this.paymentUpdateData.code;
      this.independentSettlement = this.paymentUpdateData.independent_settlement || 0;
      //  this.status = this.paymentUpdateData.row.status;
      if(this.paymentUpdateData.withdrawal_fields){
        this.withdrawalField = this.paymentUpdateData.withdrawal_fields;
        if(this.withdrawalField.length == 1){
          let tempFields = this.withdrawalField[0]
          if(tempFields.Name == '' && tempFields.required == '' && tempFields.type == ''){
            this.checkBoxStatus = false
          }else{
            this.checkBoxStatus = true
          }
        }
        else if(this.withdrawalField.length > 1){
          this.checkBoxStatus = true
        }
      }
      // if(this.paymentUpdateData.settings){
      //   this.settingsCheckBox = true
      // }
    }
  },
  data() {
    return {
      id: "",
      index: "",
      name: "",
      code: "",
      independentSettlement: 0,
      //  status: "",
      withdrawalField: [],
      loading: false,
      size: "10px",
      withdrawalCheckBox: "",
      paymentUpdateData: [],
      show: false,

      checkBoxStatus:false,
      settingsCheckBox:false,
    };
  },
  methods: {
    ChangewithdrawalCheckBox(event) {

      // if (event.target.checked) {
      //   this.show = true;
      //   this.withdrawalField = this.paymentUpdateData.row.withdrawal_fields
      //       ? this.paymentUpdateData.row.withdrawal_fields
      //       : [];
      // } else {
      //   this.show = false;
      //   this.withdrawalField = [];
      // }
    },
    ChangeSettingsCheckBox(event) {
      this.settingsCheckBox = event.target.checked;
    },
    removeField(index) {
      this.withdrawalField.splice(index, 1);
    },
    addMoreField() {
      let params = {
        type: "",
        required: "",
        Name: ""
      };
      this.withdrawalField.push(params);
    },
    Back() {
      this.$validator.validateAll().then(valid => {
        if (!valid) {
          this.$router.push({name: "payment-method"});
          this.withdrawalField.splice(1);
        } else {
          this.$router.push({name: "payment-method"});
        }
      });
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          if(!this.checkBoxStatus){
            // let emptyField = {
            //   type: "",
            //   required: "",
            //   Name: ""
            // };
            // this.withdrawalField =[emptyField]
            this.withdrawalField =[]
          }
          this.loading = true;

          // let rawData = this.$refs.paymentMethodSettings ? this.$refs.paymentMethodSettings.getSettingsData() : {};

          let data = {
            id : this.id,
            name : this.name,
            code:this.code,
            status: 1,
            independentSettlement: this.independentSettlement,
            withdrawalFields : JSON.stringify(this.withdrawalField)
          }
          
          // if(Object.keys(rawData).length > 0){
          //   data.settings = JSON.stringify(rawData);
          // }

          this.makeRequest("post", "v1/update-payment-method", data).then(
              callResponse => {
                if (!callResponse.error) {
                  let code = callResponse.response.data.code;

                  if (code == 200) {
                    this.loading = false;
                    if (callResponse.response.data.data) {
                      let responseData = callResponse.response.data.data;
                      let storeData = this.$store.getters.getByKey("paymentMethodUpdate");
                      let rawdata = this.$store.getters.getTableData(storeData.storageKey+'_custom')
                      let rowProp = {
                        ...storeData,
                        ...responseData
                      }
                      rawdata[storeData.idx] = rowProp
                      this.$store.dispatch('setTableData', { key: storeData.storageKey+'_custom', data: {...rawdata} })

                      this.$emit('back')
                      return
                    }
                  } else {
                    this.loading = false;
                  }
                }
              }
          );
        }
      });
    }
  }
};
</script>

c
